import { useEffect } from 'react';

/**
 * Hook personalizzato per garantire lo scroll naturale in tutte le pagine
 * Rimuove le restrizioni di overflow che potrebbero bloccare la navigazione
 */
export const useGlobalScroll = () => {
  useEffect(() => {
    // Creiamo gli stili globali per lo scroll
    const globalScrollStyles = document.createElement('style');
    globalScrollStyles.id = 'global-scroll-styles';
    globalScrollStyles.textContent = `
      /* Assicuriamo che html e body permettano sempre lo scroll */
      html, body {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        height: auto !important;
        scroll-behavior: smooth;
      }
      
      /* Fix per l'App container che potrebbe bloccare lo scroll */
      .App {
        overflow: visible !important;
        height: auto !important;
        min-height: 100vh;
      }
      
      /* Fix per container principali che potrebbero bloccare lo scroll */
      .dashboard,
      .report-container,
      .journal,
      .paper-trading,
      .diary {
        overflow: visible !important;
      }
      
      /* Preserviamo solo gli overflow necessari per elementi specifici */
      .navbar {
        overflow-x: auto !important;
      }
      
      /* Smooth scroll per tutta l'applicazione */
      * {
        scroll-behavior: smooth;
      }
    `;
    
    // Aggiungiamo gli stili al head se non esistono già
    const existingStyles = document.getElementById('global-scroll-styles');
    if (!existingStyles) {
      document.head.appendChild(globalScrollStyles);
    }
    
    // Assicuriamo che il body possa scorrere
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    
    // Cleanup function
    return () => {
      // Rimuoviamo gli stili quando il componente si smonta
      const stylesToRemove = document.getElementById('global-scroll-styles');
      if (stylesToRemove) {
        document.head.removeChild(stylesToRemove);
      }
      
      // Ripristiniamo gli stili originali solo se necessario
      // (Generalmente vogliamo mantenere il comportamento di scroll)
    };
  }, []);
};

export default useGlobalScroll;
